import api from '../api/client';

const getAll = async (appId) => {
    if (!appId) throw new Error('App ID is required');
    const res = await api.get(`/api/component/get-all-components`, { params: { app_id: appId } });
    return res?.data?.data;
};

// Server-paged list for the Components data table. `query` = { page, limit, sort, dir, search, filter_* }.
const getPage = async (appId, query) => {
    if (!appId) throw new Error('App ID is required');
    const res = await api.get(`/api/component/get-all-components`, { params: { app_id: appId, ...query } });
    return res?.data?.data;
};

const addComponent = async (appId, payload) => {
    const res = await api.post('/api/component/add-new-component', payload, { params: { app_id: appId } });
    return res?.data;
};

const updateName = async (appId, payload) => {
    const res = await api.post('/api/component/update-component-name', payload, { params: { app_id: appId } });
    return res?.data;
};

const updateDescription = async (appId, payload) => {
    const res = await api.post('/api/component/update-component-description', payload, { params: { app_id: appId } });
    return res?.data;
};

const getComponentDetails = async (appId, componentName) => {
    if (!appId || !componentName) throw new Error('App ID and component name are required');
    const res = await api.get(`/api/component/get-component-details/${encodeURIComponent(componentName)}`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const removeComponent = async (appId, payload) => {
    const res = await api.delete('/api/component/remove-component', {
        params: { app_id: appId },
        data: payload,
    });
    return res?.data;
};

// ── New Mapping Methods ──────────────────────────────────────────────────────

const addRoleMapping = async (appId, payload) => {
    // payload: { rolename, component_name, role_component_access }
    const res = await api.post('/api/component/add-component-role', payload, { params: { app_id: appId } });
    return res?.data;
};

const updateRoleAccess = async (appId, payload) => {
    // payload: { rolename, component_name, updated_access }
    const res = await api.post('/api/component/update-role-component-access', payload, { params: { app_id: appId } });
    return res?.data;
};

const removeRoleMapping = async (appId, payload) => {
    // payload: { rolename, component_name }
    const res = await api.delete('/api/component/remove-component-role', {
        params: { app_id: appId },
        data: payload,
    });
    return res?.data;
};

const componentsService = {
    getAll,
    getPage,
    addComponent,
    updateName,
    updateDescription,
    getComponentDetails,
    removeComponent,
    addRoleMapping,
    updateRoleAccess,
    removeRoleMapping,
};

export default componentsService;
